import { CoincidenceTokenizer } from './Tokenizer';

export const getCoincidenceTokens = (base, search, options) => {
  const tokenizer = new CoincidenceTokenizer({
    base,
    search,
    coincidencesCount: options.coincidencesCount,
    ignoreAccents: options.ignoreAccents,
  });

  return tokenizer.tokens;
};
